import { SupportedLanguages, supportedLanguages, supportedLocales, SuppotedLocales } from '../i18n/types'
export type Locale = SuppotedLocales
/**
 * Gets the initial locale from localStorage or browser settings
 */
export function getStoredLocale(): Locale | null {
  if (typeof localStorage === 'undefined') {
    return null
  }
  return localStorage.getItem('userLocale') as Locale | null
}

/**
 * Gets the browser's preferred locale
 */
export function getBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') {
    return SuppotedLocales.EN_GB
  }
  const browserLang = navigator.language.toLowerCase()
  const matchedLocale = supportedLocales.find((locale) => browserLang.startsWith(locale.split('-')[0]))
  return matchedLocale || SuppotedLocales.EN_GB
}

/**
 * Saves the locale to localStorage
 */
export function saveLocale(locale: Locale): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('userLocale', locale)
  }
}

/**
 * Validates if a locale is supported
 */
export function isLocaleSupported(locale: string, supported: readonly SuppotedLocales[] = supportedLocales): boolean {
  return supported.includes(locale as Locale)
}

/**
 * Gets the initial locale from localStorage or browser settings with fallback
 */
export function getInitialLocale(supported: readonly SuppotedLocales[] = supportedLocales): Locale {
  const storedLocale = getStoredLocale()
  if (storedLocale && supported.includes(storedLocale)) {
    return storedLocale
  }

  const browserLocale = getBrowserLocale()
  if (supported.includes(browserLocale)) {
    return browserLocale
  }

  return SuppotedLocales.EN_GB
}
